import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';
import { CustomDatePipe } from 'src/app/_pipes/custom-date.pipe';
import { CardComponent } from 'src/app/shared/ui-kit/card/card.component';

import { PolicyUpdateMetadataComponentAbstract } from '../../metadata-components/policy-update-metadata/policy-update-metadata.component.abstract';

@Component({
  selector: 'app-policy-update-metadata-v2',
  standalone: true,
  imports: [CommonModule, RouterLink, CardComponent, CustomDatePipe],
  templateUrl: './policy-update-metadata-v2.component.html',
  styleUrls: ['./policy-update-metadata-v2.component.css'],
})
export class PolicyUpdateMetadataV2Component extends PolicyUpdateMetadataComponentAbstract {}
